<template>
  <h3><slot/></h3>
</template>

<script>
export default {
  name: 'title-bar',
  methods: {
    back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
h3 {
  padding: 5px 20px;

  color: rgb(73, 48, 48);

  background-image: url('../assets/ui/legend-left.png');
  background-position: left bottom;
  background-repeat: no-repeat;
  background-size: contain;
}
.back {
  width: 30px;
  height: 30px;
  margin: auto 5px;
  display: inline-block;
  background-image: url('../assets/ui/btn2.png');
  background-size: contain;
  cursor: pointer;
}
</style>
